import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react'
import FileUpload from '../../../utility/fileUpload/fileUpload';
import GlobalButton from '../../../utility/globalButton/button';
import style from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";

interface ProductCardTemplateProps {
    files: any, 
    setFiles: any, 
    onClickOfContinueOfUploadCSVBtn: () => void,
    setFieldsOfCSV: React.Dispatch<React.SetStateAction<string[]>>, 
    jsonProductArray: any,
    setJsonProductArray: any,
} 

const ProductCardTemplate: React.FC<ProductCardTemplateProps> = (props) => {

    const {files, setFiles, onClickOfContinueOfUploadCSVBtn, setFieldsOfCSV, jsonProductArray, setJsonProductArray} = props; 


    const uploadFile = (event: any) => {
        const file = event.target.files[0];
        if (!file) return;
        
        setFiles([file]);
        const reader = new FileReader();

        reader.onload = (e) => {
            const text = e.target?.result;
            if (typeof text === "string") {
                const json = csvToJson(text);
                if(json.length > 0){
                    setFieldsOfCSV(Object.keys(json[0]));
                }
                setJsonProductArray(json);
            } else {
                console.error("File content is not a string.");
            }
        };

        reader.readAsText(file);
    } 

    function csvToJson(csvString: string) {
        const [headerLine, ...lines] = csvString.trim().split("\n");
        const headers = headerLine.split(",");

        return lines.map(line => {
            const values = line.split(",");
            return headers.reduce((obj: any, header, i) => {
                obj[header.trim()] = values[i]?.trim();
                return obj;
            }, {});
        });
    } 

    const removeFile = () => {
        setFiles([]);
        setFieldsOfCSV([]);
        setJsonProductArray(null);
    }

    return (
        <>
            <Grid container direction={"column"} gap={"12px"} sx={{ borderRadius: "5px", background: "#EFEFEF", padding: "15px" }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="space-between" gap={"11px"} alignItems="center">
                        <Grid item>
                            <Typography className={style.importCSVTitle}>Import Product (Upload CSV File)</Typography>
                            <Typography className={style.importCSVLimit}>The maximum product upload limit is <span className={globalStyles.blackColor}>10,000</span> products.</Typography>
                            {/* <Typography className={style.importCSVLimit}>Phone number must start with the country code</Typography> */}
                            <Typography className={style.importCSVLimit}><span className={globalStyles.blackColor}>Product Name</span> and <span className={globalStyles.blackColor}>Product Price</span> are mandatory fields. Products missing either of these will not be imported.</Typography>
                        </Grid>
                        {/* <Grid item>
                            <Grid container justifyContent="space-between" alignItems="center" gap={"5px"} onClick={() => { downloadSampleCSVTemplate() }}>
                                <img src={downloadCsvFileIcon} alt="downloadCSVIcon" style={{ cursor: "pointer" }} />
                                <Typography className={style.downloadSampleCSVTemplateText}>View Sample CSV Template</Typography>
                            </Grid>
                        </Grid> */}
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{ width: "100%" }}>
                    <FileUpload
                        uploadedFileDetails={files}
                        multipleFileAllow={true}
                        fileSizeAllowed={3}
                        fileTypeAllowed={'.csv, application/csv'}
                        fileNumberAllowed={1}
                        isDisabled={false}
                        uploadFileHandler={uploadFile} 
                        removeFileHandler={removeFile}
                        bgColor={"#fff"}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid container justifyContent={"space-between"} alignItems={"start"}>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Continue"}
                                className='primaryButtonStyle'
                                sx={{ width: "130px" }}
                                // disabled={files.length === 0} 
                                disabled={!jsonProductArray || jsonProductArray.length == 0}
                                onClick={(e) => { onClickOfContinueOfUploadCSVBtn() }}
                            />
                        </Grid>
                        {jsonProductArray && 
                            <>
                                {jsonProductArray.length == 0 ?
                                        <Grid item>
                                            <Typography className={style.noContactsFoundTypography}>No Products Found!</Typography>
                                        </Grid>
                                    : 
                                         <Grid item>
                                            <Typography className={style.contactsTitleTypography}>{jsonProductArray.length} Products</Typography>
                                        </Grid>
                                }
                            </>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ProductCardTemplate
